import { ScheduledEmailTemplates } from "@/common/api.service"
import { FETCH_SCHEDULED_EMAIL_TEMPLATES, FETCH_INDIVIDUAL_SCHEDULED_MAIL_TEMPLATE, SEND_SCHEDULED_TEST_MAIL, ADD_SCHEDULED_MAIL_TEMPLATE, UPDATE_SCHEDULED_MAIL_TEMPLATE,RESET_STATE, DELETE_SCHEDULED_EMAIL_TEMPLATE } from "./actions.type"
import { SET_EMAIL_TEMPLATES, SET_INDIVIDUAL_TEMPLATE, SET_ERROR_TEMPLATE,STATE_RESET } from "./mutations.type"

const initialState = () => {
    return {
        scheduledemailtemplates:[],
        sindividualtemplate: [],
        templateerrors: null,
    }
}

let state = initialState()

const getters = {
    scheduledemailtemplates(state){
        return state.scheduledemailtemplates
    },
    sindividualtemplate(state) {
        return state.sindividualtemplate
    }
}

const actions = {
    async [FETCH_SCHEDULED_EMAIL_TEMPLATES](context, slug) {
        const { data } = await ScheduledEmailTemplates.get(''+slug)
        context.commit(SET_EMAIL_TEMPLATES, data.data)
        return data;
    },
    async [FETCH_INDIVIDUAL_SCHEDULED_MAIL_TEMPLATE](context, slug) {
        const { data } = await ScheduledEmailTemplates.get(slug)
        context.commit(SET_INDIVIDUAL_TEMPLATE, data.data)
        return data;
    },  
    async [SEND_SCHEDULED_TEST_MAIL](context, payload) {
        return await ScheduledEmailTemplates.test(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },  
    async [ADD_SCHEDULED_MAIL_TEMPLATE](context, payload) {
        return await ScheduledEmailTemplates.create(payload, '')
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },     
    async [UPDATE_SCHEDULED_MAIL_TEMPLATE](context, payload) {
        return await ScheduledEmailTemplates.update(payload, payload.id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },  
    async [DELETE_SCHEDULED_EMAIL_TEMPLATE] (context, id) {
        return await ScheduledEmailTemplates.delete(id)
        .then(({ data }) => {
          return data
        })
        .catch(error => {
          context.commit(SET_ERROR_TEMPLATE, error.response.data.errors)
        });
    },    
    [RESET_STATE]({ commit }) {
        commit(STATE_RESET);
    }
}

const mutations = {
    [SET_EMAIL_TEMPLATES](state, templates) {
        state.scheduledemailtemplates = templates
    }, 
    [SET_ERROR_TEMPLATE](state, error) {
        state.templateerrors = error
    },      
    [SET_INDIVIDUAL_TEMPLATE](state, sindividualtemplate) {
        state.sindividualtemplate = sindividualtemplate
    },    
    [STATE_RESET](state) {
        Object.assign(state, initialState())
    } 
};

export default {
    state,
    getters,
    actions,
    mutations
};